$ = window.jQuery;

// cycle the images in the hero
export default obj => {
	if ($(".twitter-timeline", obj).length) {
		$.getScript("https://platform.twitter.com/widgets.js");
	}
};
